import { ReactElement } from 'react';
import { Button, Typography } from '@mui/material';

import { KnownDialogs, useDialog } from 'modules/dialogs';
import { Dialog } from 'modules/dialogs/components/Dialog';
import { useTranslation } from 'modules/i18n';

import { translation } from './translation';

export function SafeWalletDialog(): ReactElement | null {
  const { t, keys } = useTranslation(translation);

  const { isOpened, onClose } = useDialog(KnownDialogs.safeApp);

  if (!isOpened) {
    return null;
  }

  return (
    <Dialog
      open={isOpened}
      title={t(keys.title, undefined, true)}
      onClose={onClose}
    >
      <Typography mb={4} mt={6} textAlign="center">
        <span>{t(keys.description, undefined, true)}</span>

        <br />

        <br />

        <span>{t(keys.additional, undefined, true)}</span>
      </Typography>

      <Button size="large" onClick={onClose}>
        {t(keys.ok)}
      </Button>
    </Dialog>
  );
}
